import gql from 'graphql-tag';

export const REFETCH_POST_MALONE_SAVED_TEMPLATES_MUTATION = gql`
  mutation RefetchPostMaloneSavedTemplatesMutation($publisherId: ID!) {
    refetchPostMaloneSavedTemplates(publisherId: $publisherId) {
      savedTemplates {
        id
        externalId
        publisherId
        name
        description
        templateType
        selectable
        inputs {
          name
          type
        }
        outputs {
          name
          contentType
        }
        fetchedAt
      }
      cascadedTemplateNames
      errors
    }
  }
`;
